import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function DemoBanner({ title = "See it with your own church in mind.", body = "Book a short call with Cody or Sam. We'll show you the tools, answer your questions, and get your church set up.", testid = "demo-banner" }) {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-12 py-16 md:py-24" data-testid={testid}>
      <div className="relative overflow-hidden rounded-2xl p-8 md:p-14" style={{ background: "var(--bg-alt)", border: "1px solid var(--border-strong)" }}>
        <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full opacity-20 pointer-events-none" style={{ background: "radial-gradient(circle, var(--gold), transparent 70%)" }} />
        <div className="relative grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <h2 className="font-serif-display text-3xl md:text-5xl tracking-[-0.03em] leading-[1.05]" style={{ color: "var(--ink)" }}>{title}</h2>
            <p className="mt-4 text-sm md:text-base max-w-xl" style={{ color: "var(--ink-2)" }}>{body}</p>
          </div>
          <div className="md:col-span-4 flex md:justify-end gap-3 flex-wrap">
            <Link to="/demo" className="btn-primary" data-testid={`${testid}-demo-btn`}>Request a demo <ArrowRight size={14} /></Link>
            <Link to="/pricing" className="btn-ghost" data-testid={`${testid}-pricing-btn`}>See pricing</Link>
          </div>
        </div>
      </div>
    </section>
  );
}
